import { gql } from '@apollo/client';

import { Exercise } from '../../types';
import { exerciseFragment } from '../fragments';

export interface RemoveExerciseMutationVariables {
  courseId: string;
  subjectId: string;
  exerciseId: string;
}

export interface RemoveExerciseMutationResult {
  exercise: Exercise;
}

export const removeExerciseMutation = gql`
  mutation RemoveExerciseMutation($courseId: String!, $subjectId: String!, $exerciseId: String!) {
    exercise(courseId: $courseId, subjectId: $subjectId, exerciseId: $exerciseId)
      @rest(type: "Exercise", path: "courses/{args.courseId}/subjects/{args.subjectId}/exercises/{args.exerciseId}", method: "DELETE") {
      ...Exercise
    }
  }
  ${exerciseFragment}
`;
